import { action } from 'mobx';
import i18next from 'i18next';
import Alert from 'react-s-alert';

import { AppManager, Input } from 'core';

import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';

import { CategoryApp } from 'apps/forum/app';
import { CategoryMutation } from 'apps/forum/gql';

export class CategoryFormAppManager extends AppManager {
  static registryName = 'CategoryFormAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.categoryApp = new CategoryApp(this);
    this.categoryApp.createForm();
    this.input = new Input({
      title: () => this.categoryApp.title,
      description: () => this.categoryApp.description,
      color: () => this.categoryApp.color.slice(1),
      forumId: () => this.forumId,
    });
  }

  @action Submit = () => {
    if (this.categoryApp.form.isValid) {
      this.categoryApp.form.SetPosting(true);
      clientStore.SetPosting(true);
      this.mutations.push(
        CategoryMutation.New(this.input, {
          onSysErr: this.OnError,
          onUserErr: this.OnError,
          onSuccess: this.OnSuccess,
        }),
      );
    } else {
      this.categoryApp.form.alert();
    }
  };

  @action OnError = () => {
    this.categoryApp.form.SetPosting(false);
    clientStore.SetPosting(false);
    Alert.error(
      i18next.t('Hmm... We failed to create this Category. Please try again.'),
    );
  };

  @action OnSuccess = result => {
    this.categoryApp.form.SetPosting(false);
    this.categoryApp.form.clearDraft();
    clientStore.SetPosting(false);
    modalStore.ClearComponent();
    Alert.success(i18next.t('New Category created successfully.'));
    const router = clientStore.routerStore;
    router.navigate('initiative.forum.category', {
      initiative: clientStore.routerStore.params.get('initiative'),
      categoryId: result.urlId,
    });
  };
}
